import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';

import * as helpers from '../../utils/utils.js';
import styles from "./Bookkeeping.module.css";

import ReactLoading from 'react-loading';
import ErrorMessage from '../../components/shared/ErrorMessage.js';
import Table from '../../components/shared/table.js';
import DateFilter from '../../components/dateFilter/dateFilter.js';

import { useBooking } from '../../hooks/useBooking.js';
import PrintableTable from '../../components/shared/printableTable.js';


const Bookkeeping = () => {
  const navigate = useNavigate();
  const { getTotalMoney } = useBooking();

  const [filter, setFilter] = useState({ year: "", month: "", day: "" });

  const {
    data: moneyData,
    error: moneyError,
    isLoading: moneyIsLoading,
  } = useQuery(["moneyData", filter], () => getTotalMoney(filter), {
    staleTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 60,
    keepPreviousData: true,
  });

  if (moneyIsLoading) return (
    <div className="centering-container">
      <ReactLoading type="spin" color="#000" />
    </div>
    );

  if (moneyError) {
    console.error("Error fetching money data:", moneyError.response.data);
    return <ErrorMessage
      title="Connection Issue"
      error={"There seems to be an issue. Please try again later."}
    />;
    }

  return (
    <PrintableTable
      title="Bookings"
      actions={<DateFilter value={filter} onChange={setFilter} />}
    >
      <Table data={moneyData?.bookings} onRowClick={(row) => navigate(`../booking?booking_id=/${row.id}`)} />
    </PrintableTable>
  );
};

export default Bookkeeping;
